import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { connect } from 'react-redux';
import setSearchFOEAction from '../../redux/actions/searchReferenceActions/actionSearchFOE';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    marginTop: 10,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class SearchFoeForm extends React.Component {

    constructor(props) {
        super(props);

        localStorage.getItem('language') === 'pt-br' ?
            this.state = {
                foe: '', foes: [
                    { foe: 'Edificações' },
                    { foe: 'Edifícios históricos' },
                    { foe: 'Estádios' },
                    { foe: 'Aeroportos' },
                    { foe: 'Pontes e Rodovias' },
                    { foe: 'Estacionamentos' },
                    { foe: 'Estruturas Hidráulicas' },
                    { foe: 'Estações de tratamento de água' },
                    { foe: 'Estações de tratamento de efluentes' },
                    { foe: 'Tubulações' },
                    { foe: 'Túneis' },
                    { foe: 'Industrias' },
                    { foe: 'Energia' },
                    { foe: 'Energia  - Torres Eólicas' },
                    { foe: 'Energia  - Barragens' },
                    { foe: 'Energia  - Termoelétricas' },
                    { foe: 'Energia  - Subestações' },
                    { foe: 'Portos' },
                    { foe: 'Mineração' },
                ]
            } : localStorage.getItem('language') === 'de' ?
                this.state = {
                    foe: '', foes: [
                        { foe: 'Baustofftechnik' },
                        { foe: 'Fliesen- und Natursteinverlegung' },
                        { foe: 'Nass- und Feuchtraumlösungen' },
                        { foe: 'Bodentechnik' },
                        { foe: 'Fertigteile' },
                        { foe: 'Transportbeton' },
                        { foe: 'Hochbau (Neubau und Bauen im Bestand)' },
                        { foe: 'Mauerwerk und Historische Gebäude' },
                        { foe: 'Stadien' },
                        { foe: 'Flughäfen' },
                        { foe: 'Brücken und Straße' },
                        { foe: 'Parkgaragen' },
                        { foe: 'Wasserbauwerke' },
                        { foe: 'Trinkwasser' },
                        { foe: 'Abwasser' },
                        { foe: 'Kanalisation' },
                        { foe: 'Tunnelbauwerke' },
                        { foe: 'Industriegebäude' },
                        { foe: 'Energie' },
                        // { foe: 'Baufachhandel' },
                        // { foe: 'Baumarkt' },
                        { foe: 'Eisenbahn' },
                        // { foe: 'InterCompany - ICP' }
                    ]
                } : this.state = {
                    foe: '', foes: [
                        { foe: 'Building Material Technology' },
                        { foe: 'Tile and Natural Stone Technology' },
                        { foe: 'Wetroom Solutions' },
                        { foe: 'Flooring Technology' },
                        { foe: 'Buildings (New Construction and Maint.)' },
                        { foe: 'Mansory and Historical Buildings' },
                        { foe: 'Stadium' },
                        { foe: 'Airport' },
                        { foe: 'Bridge and Road' },
                        { foe: 'Carpark' },
                        { foe: 'Hydraulic Construction' },
                        { foe: 'Potable Water' },
                        { foe: 'Sewage Water' },
                        { foe: 'Undeground Sewer' },
                        { foe: 'Tunnelling' },
                        { foe: 'Industries' },
                        { foe: 'Energy and Renewables' },
                        // { foe: 'Builders Merchant' },
                        // { foe: 'v' },
                        { foe: 'Railway' },
                        // { foe: 'InterCompany' }
                    ]
                }
        this.props.setSearchFOEFunction('');
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeForm = this.handleChangeForm.bind(this)
    }

    handleChangeForm = (event, value) => {
        if (value !== null) {
            this.setState({ foe: value }, () => {
                this.props.setSearchFOEFunction(this.state.foe);
            });
        } else {
            this.setState({ foe: '' }, () => {
                this.props.setSearchFOEFunction(this.state.foe);
            });
        }
    }

    handleChange(event, value) {

        if (event.target.value.length > 0) {
            this.setState({ foe: event.target.value });
        }
    }

    render() {

        const { classes } = this.props;
        const { t } = this.props;

        return (
            <div>
                <Autocomplete
                    classes={classes}
                    id="combo-box-FOE"
                    autoComplete={true}
                    onChange={this.handleChangeForm}
                    options={this.state.foes}
                    isOptionEqualToValue={(option, value) => option.foe === value.foe}
                    getOptionLabel={(option) => option.foe}
                    noOptionsText={'Wrong input data'}
                    renderInput={(params) => <StyledTextField  {...params} onChange={this.handleChange} style={{ fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300, marginTop: 10 }}
                        label={t('create_ref.foe')} variant="outlined" />}
                />
            </div>
        );

    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSearchFOEFunction: searchFOE => {
            dispatch(setSearchFOEAction(searchFOE))
        }
    }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchFoeForm));